import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppRoutes, FindGamesRoutes, HostedGamesRoutes, NAVIGATION_TOKEN, NavigationProvider } from '@core';

export const createGameGuard = (): boolean | UrlTree => {
  const router: Router = inject(Router);
  const navigationProvider: NavigationProvider = inject(NAVIGATION_TOKEN);

  const allowRoutes: (string | RegExp)[] = [
    AppRoutes.FIND_GAMES,
    `${AppRoutes.FIND_GAMES}/${FindGamesRoutes.MAP}`,
    AppRoutes.DASHBOARD,
    AppRoutes.MY_GAMES,
    `${AppRoutes.HOST}/${HostedGamesRoutes.FUTURE}`,
    `${AppRoutes.HOST}/${HostedGamesRoutes.PAST}`,
    new RegExp(`^${AppRoutes.HOST}/${HostedGamesRoutes.FUTURE}/[^/]+$`)
  ];

  const previousPage: string = navigationProvider.previousPage().slice(1);

  const isAllowed: boolean = allowRoutes.some((route: string | RegExp) => {
    if (route instanceof RegExp) {
      return route.test(previousPage);
    }
    return route === previousPage;
  });

  if (isAllowed) return true;

  return router.createUrlTree([AppRoutes.ROOT]);
};
